import {TStepQuestions} from "../../types/TStepQuestions";

export const Questions: TStepQuestions = [
    // Step 1
    {
        step: 0,
        name: 'projectName',
        label: 'Project Name',
        placeholder: 'Rocket Science',
        description: 'What is the name of your project? If you don\'t have one, just give your project a codename.',
        type: 'text',
        value: '',
    },
    {
        step: 0,
        name: 'projectType',
        label: 'Project Type',
        description: 'What type of project is this?',
        type: 'project_type',
        value: 'Web',
        // options: ['Web App', 'Mobile App', 'Desktop App'],
    },
    // Step 2
    {
        step: 1,
        name: 'features',
        label: 'Features',
        description: 'What features do you need?',
        type: 'checkbox',
        value: [],
        options: [
            'User Authentication',
            'Social Media Integration',
            'Push Notifications',
            'Chat',
            'Search Functionality',
            'File Uploads',
            'Maps',
            'Video Streaming',
            'E-Commerce',
            'Real-Time Data',
            'Email Sending',
            'Data Processing',
            'Data Entry',
            'Messaging Functionality'
        ],
    },
    {
        step: 1,
        name: 'multilingual',
        label: 'Multilingual',
        description: 'Do you need a multilingual project?',
        type: 'select',
        value: '',
        options: ['Yes', 'No'],
    },
    {
        step: 1,
        name: 'paymentProvider',
        label: 'Include Payment Processing',
        description: 'Do you need to include a payment processing?',
        type: 'select',
        value: '',
        options: ['Yes', 'No'],
    },
    // Step 3
    {
        step: 2,
        name: 'design',
        label: 'Design',
        description: 'Do you need a design?',
        type: 'select',
        value: '',
        options: ['None', 'Simple', 'Intricate'],
    },
    // {
    //     step: 2,
    //     name: 'projectDescription',
    //     label: 'Project Description',
    //     description: 'Describe your project in detail',
    //     type: 'text',
    //     value: '',
    // },
    // Step 4
    {
        step: 3,
        name: 'projectTimeline',
        label: 'Project Timeline',
        description: 'When do you need the project to be completed?',
        type: 'select',
        value: '',
        options: ['< 3 Months', '3 - 6 Months', '6 - 9 Months', '9 - 12 Months'],

    },
    // {
    //     step: 3,
    //     name: 'projectBudget',
    //     label: 'Project Budget',
    //     description: 'What is your budget for this project?',
    //     type: 'slider',
    //     value: '100000',
    //     min: 10000,
    //     max: 200000,
    //     minLabel: '$10,000',
    //     maxLabel: '$200,000',
    // },

]